import { isEqual } from 'lodash-es';
export const noop = () => { };
export const valueAsSingleValue = (value) => value;
export const valueAsMultiValue = (value) => value;
export const onChangeAsSingle = (onChange) => onChange;
export const onChangeAsMulti = (onChange) => onChange;
export const isValueSelected = (selectedValue, value, multi) => multi ? valueAsMultiValue(selectedValue).some((item) => isEqual(item, value)) : isEqual(valueAsSingleValue(selectedValue), value);
// option is clickable if:
// 1. isClearable is true
// 2. multi is true and value is not selected or there are more than one selected values
// 3. multi is false and value is not selected
export const getIsClickable = (selectedValue, value, multi, isClearable) => isClearable ||
    (multi
        ? !isValueSelected(selectedValue, value, true) || valueAsMultiValue(selectedValue).length > 1
        : !isValueSelected(selectedValue, value, false));
